import React, { FC, ReactNode } from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';

export interface StepType {
    label: ReactNode | string;
    icon?: ReactNode;
    content?: ReactNode | string;
}

export interface StepsPropsType {
    activeStep?: number;
    /** When set, multiple steps can stay expanded at once (overrides single activeStep for expansion). */
    expandedSteps?: number[];
    className?: string;
    steps: StepType[];
}

const Steps: FC<StepsPropsType> = (props) => {
    const useExpandedSteps = props.expandedSteps !== undefined;

    return (
        <div style={{ width: '100%' }}>
            <Stepper
                orientation="vertical"
                activeStep={useExpandedSteps ? -1 : props.activeStep}
                className={props.className}
                nonLinear={useExpandedSteps}
            >
                {props.steps.map((step, index) => {
                    const isExpanded = useExpandedSteps
                        ? props.expandedSteps!.includes(index)
                        : props.activeStep === index;

                    return (
                        <Step key={String(index)} active={isExpanded} expanded={isExpanded}>
                            <StepLabel icon={step.icon}>{step.label}</StepLabel>
                            <StepContent>{step.content}</StepContent>
                        </Step>
                    );
                })}
            </Stepper>
        </div>
    );
};

export default Steps;
